import 'react-app-polyfill/ie11';
import 'url-search-params-polyfill';
import 'url-polyfill';
import 'whatwg-fetch';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

import { overrideComponent, setMetadata, setOptions, TeacherPersonalInfoViewModel, setViewModel } from '@sheerid/jslib';
import { defaultOptions } from './programOptions';
import { googleTagManagerHook } from './hooks/hooks';

import { StepSuccessComponent } from './components/stepComponents/StepSuccess/StepSuccessComponent';
import { StepPendingComponent } from './components/stepComponents/StepPending/StepPendingComponent';
import { StepErrorComponent } from './components/stepComponents/StepErrorComponent';

import { getQueryParamsByName } from './lib/utils/browser';

const accountId = getQueryParamsByName('accountId') || '';
const firstName = getQueryParamsByName('firstName') || '';
const lastName = getQueryParamsByName('lastName') || '';

const viewModel: TeacherPersonalInfoViewModel = {
  email: '',
  firstName,
  lastName,
  organization: { id: 0, name: '' },
  countryChoice: { value: undefined, label: '' },
  localeChoice: { value: 'en-US', label: '' },
  metadata: { accountId: accountId }
}

setViewModel(viewModel);

if (accountId === '') {
  // @ts-expect-error
  overrideComponent('StepTeacherPersonalInfoComponent', StepErrorComponent);
}

// @ts-ignore
overrideComponent('StepSuccessComponent',StepSuccessComponent);
// @ts-ignore
overrideComponent('StepPendingComponent',StepPendingComponent);
// @ts-ignore
overrideComponent('StepErrorComponent',StepErrorComponent);


setOptions(defaultOptions);
googleTagManagerHook();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
